import React from "react"

export default function Contact() {
  return (
    <footer style={wrap} id="contact">
      <div style={inner} className="contact-inner">
        <div style={grid} className="contact-grid">
          <div>
            <p style={footerName}>Agustina<br />Giraudy</p>
            <p style={footerInst}>
              Professor of Political Science<br />
              School of International Service<br />
              American University, Washington DC<br /><br />
              Visiting Distinguished Professor<br />
              Tecnológico de Monterrey
            </p>
          </div>
          <div>
            <p style={colTitle}>Research</p>
            <a href="https://scholar.google.com/citations?user=agiraudy" target="_blank" rel="noreferrer" style={footerLink}>
              Google Scholar
            </a>
            <a href="/files/cv.pdf?v=2" target="_blank" rel="noreferrer" style={footerLink}>
              Curriculum Vitae
            </a>
            <a href="https://www.american.edu/sis/faculty/giraudy.cfm" target="_blank" rel="noreferrer" style={footerLink}>
              Faculty Page
            </a>
          </div>
          <div>
            <p style={colTitle}>Connect</p>
            <a href="mailto:giraudy@american.edu" style={footerLink}>Email</a>
            <a href="https://x.com/AgustinaGiraudy" target="_blank" rel="noreferrer" style={footerLink}>X / Twitter</a>
            <a href="https://www.linkedin.com/in/agustina-giraudy-72a3b81a9/" target="_blank" rel="noreferrer" style={footerLink}>
              LinkedIn
            </a>
            <a href="https://www.american.edu/media/request-an-interview.cfm" target="_blank" rel="noreferrer" style={footerLink}>
              Request an Interview
            </a>
          </div>
        </div>
        <div style={bottom} className="contact-bottom">
          <span style={copy}>© 2026 Agustina Giraudy</span>
          <a href="https://www.linkedin.com/in/felipesotojorquera/" target="_blank" rel="noreferrer" style={copy}>
            Site by Felipe Soto Jorquera
          </a>
        </div>
      </div>
      <style>{`
        @media (max-width: 700px) {
          .contact-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
          .contact-inner { padding: 0 20px !important; }
        }
        @media (max-width: 480px) {
          .contact-bottom { flex-direction: column !important; gap: 8px !important; text-align: center !important; }
        }
      `}</style>
    </footer>
  )
}

const wrap = {
  background: "var(--ink)",
  padding: "80px 0 40px",
}

const inner = {
  maxWidth: "1320px",
  margin: "0 auto",
  padding: "0 40px",
}

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "48px",
  marginBottom: "64px",
}

const footerName = {
  fontFamily: '"Avant Garde", sans-serif',
  fontWeight: 300,
  fontSize: "28px",
  letterSpacing: "0.05em",
  color: "white",
  marginBottom: "16px",
}

const footerInst = {
  fontSize: "16px",
  color: "rgba(255,255,255,0.55)",
  lineHeight: 1.6,
  marginBottom: 0,
}

const colTitle = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.2em",
  textTransform: "uppercase",
  color: "var(--gold)",
  marginBottom: "20px",
}

const footerLink = {
  display: "block",
  fontSize: "16px",
  color: "rgba(255,255,255,0.65)",
  textDecoration: "none",
  marginBottom: "10px",
}

const bottom = {
  borderTop: "1px solid rgba(255,255,255,0.1)",
  paddingTop: "24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}

const copy = {
  fontFamily: '"Avant Garde", sans-serif',
  fontSize: "10px",
  letterSpacing: "0.1em",
  color: "rgba(255,255,255,0.3)",
}
